import {
  BALANCE_VALUE,
  LAST_RESULTS,
  LAST_RESULTS_BONUS,
  LAST_WIN_VALUE,
  SPIN_AMOUNT,
  SPIN_AMOUNT_ACTIVE,
} from '../../stateManagment/gameState';
import { FUN_BALANCE_AMOUNT_VALUE, GAME_SCENE } from '../../core/constats';

class UserService {
  updateLastWin(amount) {
    LAST_WIN_VALUE.next(amount);
  }

  updateBalance(amount) {
    BALANCE_VALUE.next(amount);
  }

  minusBalance(num) {
    if (this.checkBalance(num)) {
      const value = BALANCE_VALUE.getValue() - num;
      BALANCE_VALUE.next(value);
      if (!value) {
        setTimeout(() => {
          this.updateBalance(FUN_BALANCE_AMOUNT_VALUE);
        }, 1000);
      }
    } else {
      this.updateBalance(FUN_BALANCE_AMOUNT_VALUE);
    }
  }

  plusBalance(num) {
    num && BALANCE_VALUE.next(+BALANCE_VALUE.getValue() + num);
  }

  updateLastResult(result) {
    LAST_RESULTS.next(result);
  }

  addLastResult(crystal) {
    LAST_RESULTS.next([crystal, ...LAST_RESULTS.getValue()].slice(0, 10));
  }

  addBonusLastResult(crystal) {
    LAST_RESULTS_BONUS.next([crystal, ...LAST_RESULTS_BONUS.getValue()].slice(0, 10));
  }

  resetBonusLastResult() {
    LAST_RESULTS_BONUS.next([]);
  }

  updateUserData(data, scene = GAME_SCENE.MAIN) {
    if (data === null) {
      return;
    }
    if (data.winAmount) {
      userService.updateLastWin(data.winAmount);
    }
    if (data.hasOwnProperty('balance')) {
      this.updateBalance(data.balance);
    } else {
      userService.plusBalance(data.winAmount);
    }
    if (scene === GAME_SCENE.MAIN) {
      userService.addLastResult(data.result);
    }
  }

  get balance() {
    return BALANCE_VALUE.getValue();
  }

  updateBalanceBuyBonusData(data) {
    if (data && data.hasOwnProperty('balance')) {
      this.updateBalance(data.balance);
    }
  }

  checkBalance(amount) {
    if (this.balance - (amount || SPIN_AMOUNT.getValue()[SPIN_AMOUNT_ACTIVE.getValue()]) >= 0) {
      return true;
    } else {
      console.error('INVALID BALANCE');
      return false;
    }
  }
}

export const userService = new UserService();
